import { AssetWithSeriesId } from 'types';

import { MediaType } from '@kaltura-ott/tvpil';
import { CollectionProgramAsset } from '@kaltura-ott/tvpil-shared';

import routes from 'routesPaths';
import { resolvePathToDetailsPage } from 'utils';

interface Props {
  data: AssetWithSeriesId;
  isSingleVod?: boolean;
  isFutureProgram: boolean;
  collectionType: string | undefined;
  mediaTypeParam: MediaType;
  isChannelAsset: boolean;
  isAsPlayAsset: boolean;
  isProgramLive: boolean;
  hasNoDirectPlayback?: boolean;
}

export function resolveLinkProgramAsset({
  data,
  collectionType,
  mediaTypeParam,
  isFutureProgram,
  isSingleVod,
  isChannelAsset,
  isAsPlayAsset,
  isProgramLive,
  hasNoDirectPlayback,
}: Props) {
  let link;

  if (!hasNoDirectPlayback && isChannelAsset || isProgramLive) {
    const id = isProgramLive ? (data as CollectionProgramAsset).channelId : data.id;

    link = routes.live.link(id, data.type);
  } else if (!hasNoDirectPlayback && isSingleVod) {
    link = routes.vod.link(data.id, data.type);
  } else if (!hasNoDirectPlayback && isAsPlayAsset) {
    link = routes.catchUp.link(data.id, data.type);
  } else {
    const { seriesId } = data as AssetWithSeriesId;

    link = resolvePathToDetailsPage({
      id: data.id,
      subtype: collectionType,
      mediaTypeParam,
      seriesId,
      isFuture: isFutureProgram, // for avoid the bugs with future recording
    });
  }

  return link;
}
